let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6AX6f")).then(() => parcelRequire('7unUy'));